import React from "react";
import { formatMoneyNumber, formatThaiDate } from "../../../../utils/util";
import styles from "./style.module.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const InstallmentReceipt = ({
  installment,
  totalInstallments,
  index,
  loanId,
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('myLoanReceipt');
  const installmentDate = formatThaiDate(
    new Date(installment?.installment_date).toISOString()
  );

  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <span className={styles.label}>{t('period')}</span>
        <span className={styles.value}>
          {index + 1} / {totalInstallments}
        </span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>{t('date')}</span>
        <span className={styles.value}>{installmentDate}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>{t('paid')}</span>
        <span className={styles.value}>
          {formatMoneyNumber(installment.total_amount)}
        </span>
      </div>
      <div className={styles.row}>
        <span className={styles.info}>{t('paidAt')} {installmentDate}</span>
      </div>
      <button
        className={styles.detailButton}
        onClick={() =>
          navigate(
            `/my-loan-receipt/${loanId}/${installment.installment_id}/detail`
          )
        }
      >
        {t('detail')}
      </button>
    </div>
  );
};

export default InstallmentReceipt;
